import { node } from 'prop-types';
import React from 'react';

export default function FooterBlockRight({ children }) {
    return (<div
        className={'footer-item-block--right'}>
        {children}
    </div>);
}

FooterBlockRight.propTypes = {
    children: node,
};